import { AppState } from 'types/app';

export const selectLocation = (state: AppState) => state.router.location;

export const selectPathname = (state: AppState) => state.router.location.pathname;
